import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 検索条件管理
const slice = createSlice({
    name: 'SearchWordData',
    // 初期値
    initialState: '',
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<string>) => action.payload,
        // 初期化
        initState: () => '',
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
